<template>
  <div>
    <b-spinner
      variant="primary"
      v-if="isSpinner"
      large
      class="pageLoadSpinners"
    />
    <div v-show="!isSpinner">
      <b-spinner
        variant="primary"
        v-if="isUpdating"
        large
        class="pageLoadSpinners"
        style="position: fixed"
      />
      <b-card no-body class="mb-0" style="height: 1000px">
        <quill-editor id="editor" :options='editorOption' ref="myQuillEditor" @change="onEditorChange($event)" v-model="content" style="height: 750px" />
      </b-card>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { BCard, BSpinner } from "bootstrap-vue";
import { quillEditor } from "vue-quill-editor";
import { mapGetters } from "vuex";
import firebase from "@/utils/firebaseInit";
import { dbCollections } from "@/utils/firebaseCollection";
import {errorEmail} from "@/utils/apiRequests.js"
import { temp } from '@/@core/directives/animations';
const currentFileName = "src/views/Setting/Termscondition.vue"
const db = firebase.firestore();

export default {
  data: () => ({
    editorOption: {
        formats : [
          'background',
          'bold',
          'color',
          'font',
          'code',
          'italic',
          'link',
          'size',
          'strike',
          'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'list',
          'align',
          'direction',
          'code-block',
          'formula'
        ],
        placeholder: "Insert text here...",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link"],
            ["template-partediario"]
          ],
        },
      },
    isSpinner: false,
    isUpdating: false,
    content: ``,
    tacId: "",
    recheckContent: "",
    entry: false,
    fileIsBigOrNot: false 
  }),
  components: {
    quillEditor,
    BCard,
    BSpinner,
  },
  beforeDestroy() {
    this.$root.$off("updateTNC");
  },
  created() {
    this.dataGet();
  },
  mounted() {
    try {
      this.$root.$on("updateTNC", () => {
        var textSimple = this.content.replace(/<[^>]+>/g, '')
        if (textSimple === "" || textSimple.trim() === "") {
          this.content = "";
          this.isSpinner = false;
          setTimeout(()=>{
            this.$root.$emit('stopButtonDisabled')
          },500)
          this.$root.$emit("showToastMessage","Terms and conditions must not be blank.","danger");
          return;
        }
        if(this.content === this.recheckContent){
          this.$root.$emit("showToastMessage", "It appears there have been no changes to terms and conditions.","danger");
          this.isSpinner = false;
          setTimeout(()=>{
            this.$root.$emit('stopButtonDisabled')
          },500)
          return;
        }
        if (this.entry === true) {
          try {
            this.recheckContent = this.content
            this.isSpinner = true;
            let newObjectToUpdate = {
                updatedAt: new Date(),
                termsAndCondition: this.content,
              }
            db
              .collection(dbCollections.SETTINGS)
              .doc("setting")
              .collection(dbCollections.TAC)
              .doc("termsandcondition")
              .update(newObjectToUpdate)
              .then(()=>{
                this.$root.$emit( "showToastMessage","Terms and conditions updated successfully.","success");
                this.isSpinner = false;
                this.$root.$emit('stopButtonDisabled')
              })
              .catch((err)=>{
                console.error("error",err);
                this.isSpinner = false;
                this.$root.$emit('stopButtonDisabled')
              })
          } catch (error) {
            console.error("caatch error", error);
            this.$root.$emit('stopButtonDisabled')
            this.isSpinner = false
            this.$root.$emit( "showToastMessage","Some thing went wrong.","danger");
          }
        } else if (this.entry === false) {
          try {
            this.recheckContent = this.content
            this.entry = true;
            this.isSpinner = true;
            db
              .collection(dbCollections.SETTINGS)
              .doc("setting")
              .collection(dbCollections.TAC)
              .doc("termsandcondition")
              .set({
                createdAt: new Date(),
                termsAndCondition: this.content,
              }).then(()=>{
                this.$root.$emit("showToastMessage","Terms and conditions created successfully.", "success");
                this.isSpinner = false;
                this.$root.$emit('stopButtonDisabled')
              }).catch((error) => {
                  console.error(error);
              })
          } catch (error) {
            this.isSpinner = false
            this.$root.$emit('stopButtonDisabled')
            this.$root.$emit( "showToastMessage","Some thing went wrong.","danger");
          }
        }
      });
    } catch (error) {
      console.error("err", error);
      this.isSpinner = false;
      this.$root.$emit('stopSpinner');
      errorEmail({
        projectName : process.env.VUE_APP_PROJECTNAME,
        environment : process.env.NODE_ENV,
        fileName : currentFileName,
        hookName : "updateTNC",
        errorMessage : error.message
      },(res) => {
          if(res.error) {
              console.error(error);
          }
      });
    }
  },
  methods: {
    onEditorChange({ quill, html, text }) {
    },  
    dataInBox() {
    },
    dataGet() {
      try {
        this.isSpinner = true
        this.$root.$emit('startButtonDisabled');
        db.collection(dbCollections.SETTINGS)
          .doc("setting")
          .collection(dbCollections.TAC)
          .get()
          .then((snapshot) => {
            let response = [];
            if (!snapshot.empty) {
              snapshot.forEach((doc) => {
                response.push({ id: doc.id, ...doc.data() });
              });
              this.entry = true;
              this.content = response[0].termsAndCondition;
              this.recheckContent = response[0].termsAndCondition;
            } else {
              this.entry = false;
            }
            this.isSpinner = false
            this.$root.$emit('stopButtonDisabled')
          }).catch((error)=>{
            console.error("error",error)
            setTimeout(()=>{
              this.$root.$emit('stopButtonDisabled')            
            },200)
          })
      } catch (error) {
        errorEmail({
          projectName : process.env.VUE_APP_PROJECTNAME,
          environment : process.env.NODE_ENV,
          fileName : currentFileName,
          hookName : "dataGet",
          errorMessage : error.message
        },(res)=>{ 
          if(res.data){
          }else if(res.error){
            console.error(res.error)
          }
        })
        console.error("error", error);
      }
    },
  },
  computed: {
    ...mapGetters({
      tacs: "termsAndCondition/getTAC",
    }),
  },
};
</script>